export default __webpack_public_path__ + "static/intro-cond-bold-7cb686fca6718e01719e2220c8452447.woff2";